import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  type ISearchCollectionV3Item,
  searchCollectionsV3ResponseSchema,
} from './search-collections-v3-response';

export async function searchCollectionsV3Api(query: string) {
  return getRequest<IAPI<ISearchCollectionV3Item[]>>({
    path: '/collections/v3/search',
    options: { params: { query } },
    schema: searchCollectionsV3ResponseSchema,
  });
}
